module.exports = __webpack_public_path__ + "img/bet_amount_icon.401b5025.svg";